import { QRCodeSVG } from "qrcode.react";
import { cn } from "@/lib/cn";

type Props = {
  url: string;
  label?: string;
  size?: number;
  className?: string;
};

export function QRBlock({ url, label, size = 280, className }: Props) {
  return (
    <div
      className={cn(
        "flex flex-col items-center gap-4 rounded-xl p-6 glass glow-border",
        className,
      )}
    >
      <div className="rounded-lg bg-white p-5">
        <QRCodeSVG
          value={url}
          size={size}
          level="H"
          bgColor="#FFFFFF"
          fgColor="#050714"
          marginSize={0}
        />
      </div>
      {label && (
        <div className="text-center">
          <div className="text-sm text-white/60">{label}</div>
          <div className="mt-1 font-mono text-sm text-white/90">{url.replace(/^https?:\/\//, "")}</div>
        </div>
      )}
    </div>
  );
}
